module.exports = __webpack_public_path__ + "03_medium_brown.6bda4f0a.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/mama/layer5/03_medium_brown.png
// module id = S8O7
// module chunks = 0